import { init as initStickyPlayer } from '../sticky-hero-player/sticky-hero-player';
import { createSkyPlayersManager } from '../../utils/video-player-utils';

import {
  addSafariPlayerCardClass,
  clearPlayersLive,
  getPlayerConfigList,
  initHeroPlaylist,
  setPlayerListToStore,
  setVolumeOverride,
} from './helpers';
import { $heroPlaylist, PLAYER_IN_INTRO_CLASSNAME } from './constants';

const $playerInIntro = document.querySelector(PLAYER_IN_INTRO_CLASSNAME);

const skyPlayersManagerOnPage = createSkyPlayersManager();

/**
 *
 * @param {*} $players is an OPTIONAL NodeList
 * @returns { playerList, playerConfigList }
 */
export const init = ($players) => {
  addSafariPlayerCardClass();
  clearPlayersLive();
  const skyPlayersManager = skyPlayersManagerOnPage.init();
  const playerConfigList = getPlayerConfigList($players);
  const playerList = skyPlayersManager.initPlayerList(playerConfigList);
  const playersObject = { playerList, playerConfigList };
  setPlayerListToStore(playersObject);
  setVolumeOverride(playersObject);
  const shouldInitStickyPlayer =
    $playerInIntro && playerConfigList.find((config) => config.containerid === $playerInIntro.id);
  const shouldInitHeroPlaylist = $playerInIntro && $heroPlaylist;
  if (shouldInitHeroPlaylist) {
    initHeroPlaylist({ playerList, playerConfigList, skyPlayersManager, $playerInIntro });
  }
  if (shouldInitStickyPlayer) {
    initStickyPlayer(playersObject);
  }
  return playersObject;
};
